// @flow

export const SET_SCREEN_AUDIO_SHARE_STATE = 'SET_SCREEN_AUDIO_SHARE_STATE';

export const SET_SCREEN_VIDEO_SHARE_STATE = 'SET_SCREEN_VIDEO_SHARE_STATE';